import { intToDurationObject } from '@openticket/lib-utils';
/**
 * This class generates notifications from events. These events
 * are then received by clients which decide to show a notifcation to the user.
 */
export default class OpenTicketBaseNotifications {
    constructor(base) {
        this._shop = base;
        // Listen for coupon events
        this._shop._eventBus.on(['cart', 'coupon'], (path) => {
            switch (path[2]) {
                case 'add':
                    this._send({ type: 'is-success', message: 'Coupon applied', slug: 'sdkshop.notifications.coupon_applied' });
                    break;
                case 'remove':
                    this._send({ type: 'is-warning', message: 'Coupon removed', slug: 'sdkshop.notifications.coupon_removed' });
                    break;
                case 'update':
                default:
                    // No-op
                    break;
            }
        });
        let countdownStart = null;
        let countdownWarningShown = false;
        let countdownDangerShown = false;
        // Listen for timer events
        this._shop.events.on(['timer'], (path, data) => {
            switch (path[1]) {
                case 'start':
                    countdownStart = data.secondsRemaining;
                    this._send({
                        type: 'is-info',
                        message: `Reserved for ${intToDurationObject(data.secondsRemaining || 0)['minutes']}`,
                        slug: 'sdkshop.notifications.reservation_started',
                        slugData: intToDurationObject(data.secondsRemaining || 0),
                    });
                    break;
                case 'tick':
                    if (!countdownWarningShown &&
                        countdownStart &&
                        data.secondsRemaining &&
                        (countdownStart < data.secondsRemaining)) {
                        countdownWarningShown = true;
                        this._send({
                            type: 'is-warning',
                            message: `Reserved for ${intToDurationObject(data.secondsRemaining || 0)['minutes']}`,
                            slug: 'sdkshop.notifications.reservation_expiration_warning',
                            slugData: intToDurationObject(data.secondsRemaining || 0),
                        });
                    }
                    break;
                case 'clear':
                    if (!countdownDangerShown) {
                        if (data.timeout) {
                            countdownDangerShown = true;
                            this._send({
                                type: 'is-danger',
                                message: 'Reservation expired',
                                slug: 'sdkshop.notifications.reservation_expired',
                            });
                        }
                        else {
                            this._send({
                                type: 'is-info',
                                message: 'Cart cleared',
                                slug: 'sdkshop.notifications.cart_cleared',
                            });
                        }
                    }
                    break;
            }
        });
    }
    /**
     * Send a notification over the notification channel
     * @param data - Notification configuration
     */
    send(data) {
        this._send(data);
    }
    _send(data) {
        this._shop.events.emit(['notification'], data);
    }
}
export { OpenTicketBaseNotifications, };
//# sourceMappingURL=notifications.js.map